var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-layout",
    { attrs: { wrap: "" } },
    [
      _c(
        "v-flex",
        { attrs: { xs12: "" } },
        [
          _c(
            "v-card",
            [
              _c(
                "v-toolbar",
                { attrs: { dense: "", dark: "", color: _vm.color } },
                [
                  _c("v-toolbar-title", [_vm._v(_vm._s(_vm.title))]),
                  _vm._v(" "),
                  _c("v-spacer"),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: {
                        small: "",
                        color: "add",
                        disabled: !(
                          _vm.addCoFactorList && _vm.addCoFactorList.length
                        ),
                      },
                      on: {
                        click: function ($event) {
                          return _vm.clickEditDefaultValueDialog({}, true)
                        },
                      },
                    },
                    [
                      _c("v-icon", { staticClass: "mr-1" }, [_vm._v("add")]),
                      _vm._v(_vm._s(_vm.$t("Button.Add")) + "\n        "),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _vm.mapSameAnalyte.length
                ? _c(
                    "v-card-text",
                    [
                      _c(
                        "v-alert",
                        {
                          attrs: { type: "warning", outline: "" },
                          model: {
                            value: _vm.mapSameAnalyte.length,
                            callback: function ($$v) {
                              _vm.$set(_vm.mapSameAnalyte, "length", $$v)
                            },
                            expression: "mapSameAnalyte.length",
                          },
                        },
                        [
                          _vm._l(_vm.mapSameAnalyte, function (item, index) {
                            return _c(
                              "li",
                              { key: index },
                              [
                                _vm._v("\n            Cofactors "),
                                _vm._l(item, function (cofactor, index) {
                                  return _c("span", { key: index }, [
                                    _vm._v(
                                      _vm._s(cofactor.CoFactorName) +
                                        "\n            "
                                    ),
                                    index != item.length - 1
                                      ? _c("span", [_vm._v(", ")])
                                      : _vm._e(),
                                  ])
                                }),
                                _vm._v(
                                  "are mapped to the same analyte " +
                                    _vm._s(item[0].AnalyteName) +
                                    ".\n          "
                                ),
                              ],
                              2
                            )
                          }),
                          _vm._v(" "),
                          _c("div", [_vm._v(_vm._s(_vm.mapSameAnalyteText))]),
                        ],
                        2
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c("v-data-table", {
                attrs: {
                  headers: _vm.headers,
                  items: _vm.defaultValuesHasMapSameAnalyte,
                  loading: _vm.isLoading,
                  pagination: _vm.pagination,
                  "item-key": "key",
                  expand: _vm.expand,
                },
                on: {
                  "update:pagination": function ($event) {
                    _vm.pagination = $event
                  },
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "items",
                      fn: function (props) {
                        return [
                          props.item.value.length
                            ? _c(
                                "tr",
                                {
                                  staticClass: "pointer",
                                  class: [
                                    _vm.conflicting(props.item)
                                      ? "error lighten-4"
                                      : "amber lighten-4",
                                  ],
                                  on: {
                                    click: function ($event) {
                                      props.expanded = !props.expanded
                                    },
                                  },
                                },
                                [
                                  _c(
                                    "td",
                                    [
                                      _c(
                                        "v-tooltip",
                                        {
                                          attrs: { top: "" },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "activator",
                                                fn: function ({ on }) {
                                                  return [
                                                    _c(
                                                      "span",
                                                      _vm._g({}, on),
                                                      [
                                                        _vm._l(
                                                          props.item.value,
                                                          function (i, index) {
                                                            return _c(
                                                              "span",
                                                              { key: i.Id },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    i.CoFactorName
                                                                  ) +
                                                                    "\n                    "
                                                                ),
                                                                index + 1 !=
                                                                props.item.value
                                                                  .length
                                                                  ? _c("span", [
                                                                      _vm._v(
                                                                        ",  "
                                                                      ),
                                                                    ])
                                                                  : _vm._e(),
                                                              ]
                                                            )
                                                          }
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "v-icon",
                                                          {
                                                            attrs: {
                                                              color: "primary",
                                                              dark: "",
                                                              small: "",
                                                            },
                                                          },
                                                          [_vm._v("info")]
                                                        ),
                                                      ],
                                                      2
                                                    ),
                                                  ]
                                                },
                                              },
                                            ],
                                            null,
                                            true
                                          ),
                                        },
                                        [
                                          _vm._v(" "),
                                          _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.linkAnalyteName(
                                                  props.item.value
                                                )
                                              )
                                            ),
                                          ]),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c("td", { attrs: { colspan: "3" } }, [
                                    _vm.conflicting(props.item)
                                      ? _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "GuidelineAnalyteDefaultValues.hasConflictingMsg"
                                              )
                                            )
                                          ),
                                        ])
                                      : _vm._e(),
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "td",
                                    { staticClass: "text-xs-left" },
                                    [
                                      _c(
                                        "v-btn",
                                        {
                                          attrs: {
                                            small: "",
                                            dark: "",
                                            color: "warning",
                                          },
                                          on: {
                                            click: function ($event) {
                                              $event.stopPropagation()
                                            },
                                          },
                                          nativeOn: {
                                            click: function ($event) {
                                              return _vm.clickEditMapSameAnalyte(
                                                props.item
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _c(
                                            "v-icon",
                                            { staticClass: "mr-1" },
                                            [_vm._v("edit")]
                                          ),
                                          _vm._v(
                                            _vm._s(_vm.$t("Button.Edit")) +
                                              "\n              "
                                          ),
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "v-btn",
                                        { attrs: { small: "" } },
                                        [
                                          _c(
                                            "v-icon",
                                            { staticClass: "mr-1" },
                                            [_vm._v("expand_more")]
                                          ),
                                          _vm._v("expand\n              "),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ]
                              )
                            : _c("tr", [
                                _c("td", [
                                  _vm._v(_vm._s(props.item.value.CoFactorName)),
                                ]),
                                _vm._v(" "),
                                _c("td", [
                                  _vm._v(_vm._s(props.item.value.DefaultValue)),
                                ]),
                                _vm._v(" "),
                                _c("td", [
                                  _vm._v(_vm._s(props.item.value.Unit)),
                                ]),
                                _vm._v(" "),
                                _c("td", [
                                  _vm._v(_vm._s(props.item.value.Description)),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "td",
                                  { staticClass: "text-xs-left" },
                                  [
                                    _c(
                                      "v-btn",
                                      {
                                        attrs: {
                                          small: "",
                                          dark: "",
                                          color: "warning",
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.clickEditDefaultValueDialog(
                                              props.item.value
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _c("v-icon", { staticClass: "mr-1" }, [
                                          _vm._v("edit"),
                                        ]),
                                        _vm._v(
                                          _vm._s(_vm.$t("Button.Edit")) +
                                            "\n              "
                                        ),
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _vm.canRemoveValues
                                      ? _c(
                                          "v-btn",
                                          {
                                            attrs: {
                                              small: "",
                                              dark: "",
                                              color: "delete",
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.clickRemoveDefaultValueDialog(
                                                  props.item.value
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _c(
                                              "v-icon",
                                              { staticClass: "mr-1" },
                                              [_vm._v("delete_forever")]
                                            ),
                                            _vm._v(
                                              _vm._s(_vm.$t("Button.Remove")) +
                                                "\n              "
                                            ),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                  ],
                                  1
                                ),
                              ]),
                        ]
                      },
                    },
                    {
                      key: "expand",
                      fn: function (props) {
                        return props.item.value.length
                          ? [
                              _c("v-data-table", {
                                attrs: {
                                  headers: _vm.headers,
                                  items: props.item.value,
                                  data: props.item,
                                  "hide-actions": "",
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "items",
                                      fn: function (props) {
                                        return [
                                          _c(
                                            "tr",
                                            { class: ["grey lighten-4"] },
                                            [
                                              _c("td", [
                                                _vm._v(
                                                  _vm._s(
                                                    props.item.CoFactorName
                                                  )
                                                ),
                                              ]),
                                              _vm._v(" "),
                                              _c("td", [
                                                _vm._v(
                                                  _vm._s(
                                                    props.item.DefaultValue
                                                  )
                                                ),
                                              ]),
                                              _vm._v(" "),
                                              _c("td", [
                                                _vm._v(_vm._s(props.item.Unit)),
                                              ]),
                                              _vm._v(" "),
                                              _c("td", [
                                                _vm._v(
                                                  _vm._s(props.item.Description)
                                                ),
                                              ]),
                                              _vm._v(" "),
                                              _c(
                                                "td",
                                                { staticClass: "text-xs-left" },
                                                [
                                                  props.item.conflicting
                                                    ? _c(
                                                        "v-btn",
                                                        {
                                                          attrs: {
                                                            small: "",
                                                            color: "success",
                                                          },
                                                          on: {
                                                            click: function (
                                                              $event
                                                            ) {
                                                              return _vm.SetAsResolvedDefaultValue(
                                                                props.item
                                                              )
                                                            },
                                                          },
                                                        },
                                                        [
                                                          _c(
                                                            "v-icon",
                                                            {
                                                              staticClass:
                                                                "mr-1",
                                                            },
                                                            [_vm._v("done")]
                                                          ),
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.$t(
                                                                "Button.SetAsResolvedDefaultValue"
                                                              )
                                                            ) +
                                                              "\n                  "
                                                          ),
                                                        ],
                                                        1
                                                      )
                                                    : _vm._e(),
                                                  _vm._v(" "),
                                                  _vm.canRemoveValues
                                                    ? _c(
                                                        "v-btn",
                                                        {
                                                          attrs: {
                                                            small: "",
                                                            dark: "",
                                                            color: "delete",
                                                          },
                                                          on: {
                                                            click: function (
                                                              $event
                                                            ) {
                                                              return _vm.clickRemoveDefaultValueDialog(
                                                                props.item
                                                              )
                                                            },
                                                          },
                                                        },
                                                        [
                                                          _c(
                                                            "v-icon",
                                                            {
                                                              staticClass:
                                                                "mr-1",
                                                            },
                                                            [
                                                              _vm._v(
                                                                "delete_forever"
                                                              ),
                                                            ]
                                                          ),
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.$t(
                                                                "Button.Remove"
                                                              )
                                                            ) +
                                                              "\n                  "
                                                          ),
                                                        ],
                                                        1
                                                      )
                                                    : _vm._e(),
                                                ],
                                                1
                                              ),
                                            ]
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  true
                                ),
                              }),
                            ]
                          : undefined
                      },
                    },
                  ],
                  null,
                  true
                ),
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-dialog",
        {
          attrs: { persistent: "", "max-width": "800px" },
          model: {
            value: _vm.editDialog,
            callback: function ($$v) {
              _vm.editDialog = $$v
            },
            expression: "editDialog",
          },
        },
        [
          _c(
            "v-card",
            [
              _c(
                "v-toolbar",
                { attrs: { dark: "", color: "primary" } },
                [
                  _c("v-toolbar-title", [_vm._v(_vm._s(_vm.editDialogTitle))]),
                  _vm._v(" "),
                  _c("v-spacer"),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: { icon: "", dark: "" },
                      on: { click: _vm.clearAndCloseEditForm },
                    },
                    [_c("v-icon", [_vm._v("close")])],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _vm.isLoading
                ? _c("v-progress-linear", { attrs: { indeterminate: "" } })
                : _vm._e(),
              _vm._v(" "),
              _c(
                "v-form",
                {
                  ref: "editForm",
                  staticStyle: { width: "100%" },
                  model: {
                    value: _vm.editFormIsValid,
                    callback: function ($$v) {
                      _vm.editFormIsValid = $$v
                    },
                    expression: "editFormIsValid",
                  },
                },
                [
                  _c(
                    "v-card-text",
                    [
                      _c(
                        "v-layout",
                        { attrs: { wrap: "", "pl-5": "", "pr-5": "" } },
                        [
                          _c(
                            "v-flex",
                            { attrs: { xs12: "" } },
                            [
                              _vm.isAddingNewValue
                                ? _c("v-autocomplete", {
                                    attrs: {
                                      label: "CoFactor",
                                      items: _vm.addCoFactorList,
                                      "item-text": "Name",
                                      "item-value": "Id",
                                      disabled: !_vm.isAddingNewValue,
                                    },
                                    model: {
                                      value: _vm.editDefaultValue.CoFactorId,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.editDefaultValue,
                                          "CoFactorId",
                                          $$v
                                        )
                                      },
                                      expression: "editDefaultValue.CoFactorId",
                                    },
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              !_vm.isAddingNewValue
                                ? _c("v-autocomplete", {
                                    attrs: {
                                      label: "CoFactor",
                                      items: _vm.cofactorList,
                                      "item-text": "Name",
                                      "item-value": "Id",
                                      disabled: !_vm.isAddingNewValue,
                                    },
                                    model: {
                                      value: _vm.editDefaultValue.CoFactorId,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.editDefaultValue,
                                          "CoFactorId",
                                          $$v
                                        )
                                      },
                                      expression: "editDefaultValue.CoFactorId",
                                    },
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              _c("v-text-field", {
                                attrs: {
                                  label: "DefaultValue",
                                  rules: _vm.formRuleValue,
                                },
                                model: {
                                  value: _vm.editDefaultValue.DefaultValue,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.editDefaultValue,
                                      "DefaultValue",
                                      $$v
                                    )
                                  },
                                  expression: "editDefaultValue.DefaultValue",
                                },
                              }),
                              _vm._v(" "),
                              _c("v-autocomplete", {
                                attrs: {
                                  label: "Unit",
                                  items: _vm.allUnitsShow,
                                  "item-text": "Name",
                                  "item-value": "Name",
                                },
                                model: {
                                  value: _vm.editDefaultValue.Unit,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.editDefaultValue, "Unit", $$v)
                                  },
                                  expression: "editDefaultValue.Unit",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-card-actions",
                    [
                      _c("v-spacer"),
                      _vm._v(" "),
                      _c(
                        "v-btn",
                        {
                          attrs: {
                            color: "success",
                            disabled: _vm.addSaveDisabled,
                          },
                          on: { click: _vm.clickPutDefaultValue },
                        },
                        [
                          _c("v-icon", [_vm._v("done")]),
                          _vm._v(
                            _vm._s(_vm.editDialogAddOrSave) + "\n          "
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-btn",
                        {
                          attrs: { outline: "", color: "secondary" },
                          on: { click: _vm.clearAndCloseEditForm },
                        },
                        [_vm._v(_vm._s(_vm.$t("Button.Cancel")))]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-dialog",
        {
          attrs: { persistent: "", "max-width": "800px" },
          model: {
            value: _vm.editMapSameAnalyte,
            callback: function ($$v) {
              _vm.editMapSameAnalyte = $$v
            },
            expression: "editMapSameAnalyte",
          },
        },
        [
          _c(
            "v-card",
            [
              _c(
                "v-toolbar",
                { attrs: { dark: "", color: "primary" } },
                [
                  _c("v-toolbar-title", [
                    _vm._v(_vm._s(_vm.editMapSameAnalyteDialogTitle)),
                  ]),
                  _vm._v(" "),
                  _c("v-spacer"),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: { icon: "", dark: "" },
                      on: { click: _vm.clearAndCloseEditForm },
                    },
                    [_c("v-icon", [_vm._v("close")])],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _vm.isLoading
                ? _c("v-progress-linear", { attrs: { indeterminate: "" } })
                : _vm._e(),
              _vm._v(" "),
              _c(
                "v-form",
                {
                  ref: "editForm",
                  staticStyle: { width: "100%" },
                  model: {
                    value: _vm.editFormIsValid,
                    callback: function ($$v) {
                      _vm.editFormIsValid = $$v
                    },
                    expression: "editFormIsValid",
                  },
                },
                [
                  _c(
                    "v-card-text",
                    [
                      _c(
                        "v-layout",
                        { attrs: { wrap: "", "pl-5": "", "pr-5": "" } },
                        [
                          _c(
                            "v-flex",
                            { attrs: { xs12: "" } },
                            [
                              _c("v-text-field", {
                                attrs: { label: "CoFactors", disabled: "" },
                                model: {
                                  value: _vm.editCofactors,
                                  callback: function ($$v) {
                                    _vm.editCofactors = $$v
                                  },
                                  expression: "editCofactors",
                                },
                              }),
                              _vm._v(" "),
                              _c("v-text-field", {
                                attrs: {
                                  label: "DefaultValue",
                                  rules: _vm.formRuleValue,
                                },
                                model: {
                                  value: _vm.editCofactorsDefaultValue,
                                  callback: function ($$v) {
                                    _vm.editCofactorsDefaultValue = $$v
                                  },
                                  expression: "editCofactorsDefaultValue",
                                },
                              }),
                              _vm._v(" "),
                              _c("v-autocomplete", {
                                attrs: {
                                  label: "Unit",
                                  items: _vm.allUnitsShow,
                                  "item-text": "Name",
                                  "item-value": "Name",
                                },
                                model: {
                                  value: _vm.editCofactorsUnit,
                                  callback: function ($$v) {
                                    _vm.editCofactorsUnit = $$v
                                  },
                                  expression: "editCofactorsUnit",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-card-actions",
                    [
                      _c("v-spacer"),
                      _vm._v(" "),
                      _c(
                        "v-btn",
                        {
                          attrs: {
                            color: "success",
                            disabled:
                              !_vm.editCofactorsDefaultValue ||
                              !_vm.editCofactorsUnit,
                          },
                          on: { click: _vm.putMapSameAnalyteDefaultValue },
                        },
                        [
                          _c("v-icon", [_vm._v("done")]),
                          _vm._v(
                            _vm._s(_vm.editDialogAddOrSave) + "\n          "
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-btn",
                        {
                          attrs: { outline: "", color: "secondary" },
                          on: { click: _vm.clearAndCloseEditForm },
                        },
                        [_vm._v(_vm._s(_vm.$t("Button.Cancel")))]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-dialog",
        {
          attrs: { persistent: "", "max-width": "500px" },
          model: {
            value: _vm.removeDialog,
            callback: function ($$v) {
              _vm.removeDialog = $$v
            },
            expression: "removeDialog",
          },
        },
        [
          _c(
            "v-card",
            [
              _c(
                "v-toolbar",
                {
                  staticStyle: { padding: "0px" },
                  attrs: { dense: "", color: "primary", dark: "" },
                },
                [
                  _c("v-toolbar-title", [_vm._v("Delete CoFactor Value")]),
                  _vm._v(" "),
                  _c("v-spacer"),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: { icon: "", dark: "" },
                      on: { click: _vm.clearAndCloseRemoveForm },
                    },
                    [_c("v-icon", [_vm._v("close")])],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c("v-card-text", { staticClass: "headline" }, [
                _vm._v(
                  "Are you sure you want to remove the default value for analyte:\n        " +
                    _vm._s(_vm.removeDefaultValue.CoFactorName) +
                    "?"
                ),
              ]),
              _vm._v(" "),
              _vm.isLoading
                ? _c("v-progress-linear", { attrs: { indeterminate: "" } })
                : _vm._e(),
              _vm._v(" "),
              _c("v-card-text", [
                _vm._v(
                  "Warning: If removed, the default value will not be recoverable"
                ),
              ]),
              _vm._v(" "),
              _c(
                "v-card-actions",
                [
                  _c("v-spacer"),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: { dark: "", color: "delete" },
                      nativeOn: {
                        click: function ($event) {
                          return _vm.clickDeleteDefaultValue.apply(
                            null,
                            arguments
                          )
                        },
                      },
                    },
                    [
                      _c("v-icon", [_vm._v("delete_forever")]),
                      _vm._v(_vm._s(_vm.$t("Button.Remove")) + "\n        "),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: { color: "secondary", outline: "" },
                      nativeOn: {
                        click: function ($event) {
                          return _vm.clearAndCloseRemoveForm.apply(
                            null,
                            arguments
                          )
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.$t("Button.Cancel")))]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }